import { NavLink } from "react-router";
import { MENU_ITEMS, MENU_SEP, type MenuItem } from "./Header";
import css from "./MobileMenu.module.css";
import { useT, useTurl } from "~/util/Lang";
import clsx from "clsx";
import { useState } from "react";

export function MobileMenu(props: { close: () => void }) {
  return MENU_ITEMS.map((item, i) => {
    return <MenuItem key={i} item={item} level={0} close={props.close} />;
  });
}

function MenuItem(props: { item: MenuItem; level: number; close: () => void }) {
  const t = useT();
  const turl = useTurl();

  const item = props.item;

  const [open, setOpen] = useState(props.level < 1);

  return (
    <>
      <div className={css.item}>
        <NavLink
          to={turl(item.to)}
          style={{ paddingLeft: 12 + 12 * props.level }}
          className={(opts) =>
            clsx([css.link], {
              [css.linkActive]: opts.isActive,
            })
          }
          onClick={() => props.close()}
        >
          {t(item.title)}
        </NavLink>
        {item.submenu && (
          <div
            className={css.arrowBox}
            onClick={() => setOpen((open) => !open)}
          >
            <div className={clsx(css.arrow, { [css.arrowDown]: open })} />
          </div>
        )}
      </div>
      {open &&
        item.submenu?.map((sub) => {
          if (sub === MENU_SEP) {
            return null;
          }

          return (
            <MenuItem
              key={sub.id}
              item={sub}
              level={props.level + 1}
              close={props.close}
            />
          );
        })}
    </>
  );
}
